import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Lightweight hook that resolves whether the current session belongs to an admin.
 * Returns `true` only after a successful check-admin call; defaults to `false`.
 */
export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;

    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session || cancelled) return;
      supabase.functions
        .invoke("check-admin")
        .then(({ data }) => {
          if (!cancelled) setIsAdmin(data?.is_admin === true);
        })
        .catch(() => {});
    });

    return () => { cancelled = true; };
  }, []);

  return isAdmin;
}
